import React, { useEffect, useState } from 'react';
import editIconWhite from '../../../../shared/assets/img/edit_icon_white.svg';
import { LabelValueCard, PageLoader } from '../../../../shared_elements';
import { Grid, Paper, Tooltip } from '@material-ui/core';
import { globalGetService, globalPostService, globalPutService } from '../../../../utils_v2/globalApiServices';
import { checkApiStatus, checkPermission, toastFlashMessage } from '../../../../utils_v2';
import { EditSidebar, InvoiceConfigCol } from '../../../../applications/contracts/Elements';
import { Row } from 'reactstrap';
import EditWetleaseCard from './EditWetleaseCard';
import { avationPlcInstance, leshaBankInstance, mtInstance } from '../../../../shared_elements/components';
export default function WetleaseCard({props}) {
  const [editModal, setEditModal] = useState({ modal: false });
  const [wetleasecard, SetWetleasecard] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [showMore, setShowMore] = useState({});

  useEffect(() => {
    getWetleaseCard();
  }, [])
  const toggleEditSideBar = (data) => {
    setEditModal({ modal: true, data: wetleasecard })
  }
  const getWetleaseCard = () => {
    setLoading(true);
    globalGetService(`/contracts/contract-details/${props.params.contract_slug}/`)
      .then((response) => {
        setLoading(false);
        if (checkApiStatus(response)) {
          SetWetleasecard(response?.data.data);
        }else{
            toastFlashMessage(response?.data.message, 'error');
        }
      })
  }
  const updateWetLeaseCard = (data, type, assetViewId) => {
    setLoading(true);
    globalPutService(`contracts/contract-details/${props.params.contract_slug}/`, data)
      .then(response => {
        if (checkApiStatus(response)) {
          setEditModal({ modal: false });
          getWetleaseCard();
          setLoading(false);
          toastFlashMessage('WetLease Details Updated Successfully', 'success');
        } else {
          setLoading(false);
          toastFlashMessage('Error Occured while updating WetLease Details', 'error');
        }
      }
      )
  }

  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };

  return (
    <>
    <div className="data-invoice-block" style={{marginTop:'16px'}}>
      {checkPermission('contracts','wet_lease', 'U') ?
      <h5 className="para">
        <Tooltip title="Edit WetLease Details" placement="top">
          <img style={{ float: 'right', cursor: 'pointer' }} onClick={toggleEditSideBar} width="16" color='#fff' className="editIcon" src={editIconWhite} alt="img" />
        </Tooltip>
      </h5>:null}
      <Row>
          <InvoiceConfigCol
            size="4"
            title="Right to Wet Lease without prior Approval"
            value={wetleasecard?.titan_extra_fields?.right_wetlease_without_approval||'--'}
          />
          <InvoiceConfigCol
            size="2"
            title="Wet Lease Fee"
            value={wetleasecard?.titan_extra_fields?.wetlease_fee||'--'}
          />
          {(mtInstance || avationPlcInstance || leshaBankInstance) ?
          <InvoiceConfigCol
            size="6"
            title="Wet Lease Comment"
            value={wetleasecard?.titan_extra_fields?.wetlease_comment && wetleasecard?.titan_extra_fields?.wetlease_comment?.length > 200 ? (
              <div>
                {showMore[wetleasecard?.id] && showMore[wetleasecard?.id] ? (
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: wetleasecard?.titan_extra_fields?.wetlease_comment.replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#f0a4ff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(wetleasecard.id); }} >
                      less
                    </a>
                  </span>
                ) : (
                  <span>
                    <span dangerouslySetInnerHTML={{ __html: wetleasecard?.titan_extra_fields?.wetlease_comment.substring(0, 190).replace(/\n/g, '<br />') }} />
                    <a href='#' style={{ color: '#f0a4ff', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(wetleasecard.id); }} >
                      ..more
                    </a>
                  </span>
                )}
              </div>
            ) : (
              <div>
                   {wetleasecard?.titan_extra_fields?.wetlease_comment ? <span dangerouslySetInnerHTML={{ __html: wetleasecard?.titan_extra_fields?.wetlease_comment.replace(/\n/g, '<br />') }} />:'--'}
              </div>
            )} 
          />:null}
      </Row>
    </div>
      {editModal.modal ?
        <EditSidebar
          title={`Edit WetLease Details`}
          editSideBar={editModal?.modal}
          toggleEditSideBar={() => setEditModal({ modal: false })}
        >
          <EditWetleaseCard 
              type="edit"
              wetleasecard={wetleasecard}
              toggleEditSideBar={() => setEditModal({ modal: false })}
              updateWetLeaseCard={(data) => updateWetLeaseCard(data,)}
          />
        </EditSidebar> : null}
        {isLoading?<PageLoader/>:null}
    </>
  )
}
